import React, { useContext, useEffect } from 'react'
import PropTypes from 'prop-types'
import BookingsList from './BookingsList'
import BookingDetails from './BookingDetails'
import { BOOKING, BookingContext } from './BookingContext'
import { MBooking } from '../types'

const _renderRightColumn = (booking) => {
  if (!booking || !booking.hotel) {
    return <p className="padded">Select a booking to see details.</p>
  }

  return <BookingDetails booking={booking} />
}

const BookingResults = ({ bookings, meta, user }) => {
  const { state, dispatch } = useContext(BookingContext)

  useEffect(() => {
    dispatch({ type: BOOKING.ALL, payload: bookings })
    dispatch({ type: BOOKING.META, payload: meta })
    dispatch({ type: BOOKING.USER.SET, payload: user })
  }, [])

  return (
    <div className="viewport my-reservations">
      <section className="content">
        <BookingsList bookings={state.all} />
        <div className={`right column ${state.booking ? 'open' : 'closed'}`}>
          {_renderRightColumn(state.booking)}
        </div>
      </section>
    </div>
  )
}

BookingResults.propTypes = {
  bookings: PropTypes.arrayOf(MBooking),
  user: PropTypes.object,
  meta: PropTypes.object
}

export default BookingResults
